import { __awaiter } from "tslib";
import { UserService } from "@/servicesTs/models/general/user";
const moduleUser = {
    namespaced: true,
    state: {
        loading: false,
        users: {
            data: [],
            total: 0,
            per_page: 0,
            current_page: 1,
        },
        dataFilter: {},
    },
    getters: {
        getLoading(state) {
            return state.loading;
        },
        getUsers(state) {
            return state.users;
        },
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setUsers(state, data) {
            state.users = data;
        },
        setPaginated(state, page) {
            state.users.current_page = page;
        },
        setDataFilter(state, dataFilter) {
            var _a;
            state.dataFilter = Object.assign(Object.assign({}, dataFilter), { rut: ((_a = dataFilter.rut) === null || _a === void 0 ? void 0 : _a.replaceAll(".", "")) || null });
        },
        setClearFilter(state) {
            state.dataFilter = {};
        },
    },
    actions: {
        getUsers({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const USERS = yield UserService.getFilter(state.dataFilter, state.users.current_page);
                commit("setUsers", USERS);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleUser;
